import * as Papa from "papaparse";

export namespace CsvHelper {
  export async function parseFromFile<T = any>(file: File) {
    return new Promise((resolve: (data: T[]) => void, reject) => {
      try {
        Papa.parse<T>(file, {
          header: true,
          encoding: 'utf-8',
          skipEmptyLines: true,
          complete: (parsed) => {
            if (parsed.errors?.length) {
              return reject(parsed.errors);
            }

            resolve(parsed.data);
          }
        });
      }
      catch (err) {
        reject(err);
      }
    });
  }
}
